<flx-bottom-panel
  [showToggleButtons]="showToggleButtons()"
  [size]="size()"
  (sizeChange)="size.set($event)"
>
  <ng-container flxExpandPanelHeader>
    @if (uiFlowSession()) {
      <flx-ui-flow-session-details-panel-header
        [name]="uiFlowSession().uiFlowName"
        [uuid]="uiFlowSession().id"
        [state]="uiFlowSession().status"
        subtitle
      />
    }
  </ng-container>

  <ng-container>
    <flx-tab-bar
      [selectedTabIndex]="selectedTabIndex()"
      (selectedTabChange)="onTabChange($event)"
      class="flx-ds shadowless h-full px-6 pb-6"
    >
      @for (tab of tabs; track $index) {
        @if (tab.visible) {
          <flx-tab
            [label]="tab.header"
            [headerDataTestId]="`tab-${tab.id.toLowerCase()}`"
          >
            <div
              class="h-full"
              flxTabContent
            >
              @if (selectedTabIndex() === tab.index) {
                @switch (tab.header) {
                  @case (TabHeaders.VARIABLES) {
                    <flx-ui-flow-session-variables
                      [sessionId]="uiFlowSession()?.id"
                      [sessionName]="uiFlowSession()?.uiFlowName"
                      [variables]="uiFlowSession()?.variables"
                    />
                  }
                  @case (TabHeaders.AUDIT) {
                    <flx-ui-flow-session-audit-logs [sessionId]="uiFlowSession()?.id" />
                  }
                  @case (TabHeaders.PROCESSES) {
                    <flx-ui-flow-session-processes [processInstances]="processInstances()" />
                  }
                  @case (TabHeaders.WORKFLOWS) {
                    <flx-instance-workflows
                      [instanceUuid]="uiFlowSession()?.id"
                      [workflowRunTriggerTypes]="['CHAT', 'UI_FLOW']"
                    />
                  }
                }
              }
            </div>
          </flx-tab>
        }
      }
    </flx-tab-bar>
  </ng-container>
</flx-bottom-panel>
